module.exports = __webpack_public_path__ + "fonts/StyreneAWeb-Bold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/StyreneAWeb-Bold.woff
// module id = 75
// module chunks = 8